<template>
	<div>
		<vxe-modal v-model="modal" :title="title" width="1200" height="600" @show="show" show-footer destroy-on-close>
			<template #default>
				<p>
					<vxe-radio-group v-model="selectTab">
						<vxe-radio-button label="total" content="总览"></vxe-radio-button>
						<vxe-radio-button label="warehouse" content="仓库"></vxe-radio-button>
						<vxe-radio-button label="distribution" content="配货员"></vxe-radio-button>
						<vxe-radio-button label="packer" content="打包员"></vxe-radio-button>
					</vxe-radio-group>
				</p>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" height="400"
					:ref="gridRef"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="cancel"></vxe-button>
			</template>
		</vxe-modal>
		<detail-index ref="detail" :data="currentdetail" :title="detailTitle" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import detailIndex from '../detail/index.vue'
	export default {
		mixins: [listMixins],
		props: {
			row: {
				default: () => {
					return null
				}
			},
			title: {
				default: () => {
					return ''
				}
			},
			create_time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				reason_uid:['412821904868617542', '170145293685856087', '201577199464376085', '865231255347698832'],//仓库-少发货,仓库-货发错,仓库-混货,仓库-串货
				gridRef: Math.random(),
				selectTab: 'total',
				sourcedata: [],
				groupedData:[],
				modal: false,
				loading: false,
				count:[],
				list_formConfig: [],
				list_columns: [{
						field: 'originalStorage',
						title: '仓库',
					},
					// {
					// 	field: 'reason_name',
					// 	title: '原因',
					// },
					{
						field: 'num',
						title: '数量',
						sortable: true
					},
					{
						field: 'percent',
						title: '占比(%)'
					},
					{
						field: '操作',
						width:60,
						align:'center',
						slots: {
							default:({row})=>{
								return <el-button type="text" style="font-size:12px" onClick={()=>{this.detailShow(row)}}>详情</el-button>
							}
						}
					}
				],
				list_footerField: [{
					field: 'num'
				}, {
					field: 'percent',
					toFixed: 2
				}],
				detailTitle:'明细',
				currentdetail:[]
			}
		},
		watch: {
			selectTab() {
				if (this.selectTab == 'total') {
					this.list_columns = [{
							field: 'originalStorage',
							title: '仓库',
						},
						// {
						// 	field: 'reason_name',
						// 	title: '原因',
						// },
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'percent',
							title: '占比(%)'
						}
					]
				}
				if (this.selectTab == 'warehouse') {
					this.list_columns = [{
							field: 'originalStorage',
							title: '仓库',
						},
						// {
						// 	field: 'reason_name',
						// 	title: '原因',
						// },
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'percent',
							title: '占比(%)'
						}
					]
				}
				if (this.selectTab == 'distribution') {
					this.list_columns = [{
							field: 'distribution',
							title: '配货员',
						},
						// {
						// 	field: 'reason_name',
						// 	title: '原因',
						// },
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'percent',
							title: '占比(%)'
						}
					]
				}
				if (this.selectTab == 'packer') {
					this.list_columns = [{
							field: 'packer',
							title: '打包员',
						},
						// {
						// 	field: 'reason_name',
						// 	title: '原因',
						// },
						{
							field: 'num',
							title: '数量',
							sortable: true
						},
						{
							field: 'percent',
							title: '占比(%)'
						}
					]
				}
				this.list_columns.push({
						field: '操作',
						width:60,
						align:'center',
						slots: {
							default:({row})=>{
								return <el-button type="text" style="font-size:12px" onClick={()=>{this.detailShow(row)}}>详情</el-button>
							}
						}
					})
				this.$refs[this.gridRef].reloadData([])	
				this.$refs[this.gridRef].commitProxy('query')
				this.$refs[this.gridRef].reloadColumn(this.list_columns)
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = this.list_columns
			},
			list() {
				//console.log(this.create_time)
				return new Promise((resolve) => {
					this.loading = true
					let tableData = []
					this.$api.packererror.getSummary({
						create_time: this.create_time
					}).then((res) => {
						this.loading = false
						this.sourcedata = res.list
						this.count = res.count
						if (this.selectTab == 'total') {
							tableData = this.accordingTototal()
						}
						if (this.selectTab == 'warehouse') {
							tableData = this.accordingToWarehouse()
						}	
						if (this.selectTab == 'distribution') {
							tableData = this.accordingToDistribution()
						}
						if (this.selectTab == 'packer') {
							tableData = this.accordingToPacker()
						}	
						resolve({
							list: tableData
						})
						console.log(tableData)
					}, () => {
						this.loading = false
					})
				})
			},
			accordingTototal() {
				let amount = this.sourcedata.length
				let tableData = []
				let sourcedata = this.sourcedata.filter((item)=>{
					let obj = this.reason_uid.find((_item)=>{
						return _item == item.reason_uid
					})
					return obj
				})
				let groupedData = this.$Lodash.groupBy(sourcedata, 'originalStorage')
				for (let i in groupedData) {
					// groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'originalStorage')
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'originalStorage')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.originalStorage = i
						obj.reason_name = j
						obj.num = groupedData[i][j].length
						obj.percent = obj.num / amount * 100
						obj.percent = obj.percent.toFixed(2)
						tableData.push(obj)
					}
				}
				tableData = tableData.sort((a, b) => {
					return b.num - a.num
				})
				console.log(groupedData)
				this.groupedData = groupedData
				return tableData
			},
			accordingToWarehouse() {
				let amount = this.sourcedata.length
				let tableData = []
				let sourcedata = this.sourcedata.filter((item)=>{
					return item.reason_uid == '201577199464376085'
				})
				let groupedData = this.$Lodash.groupBy(sourcedata, 'originalStorage')
				for (let i in groupedData) {
					// groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'reason_name')
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'originalStorage')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.originalStorage = i
						obj.reason_name = j
						obj.num = groupedData[i][j].length
						obj.percent = obj.num / amount * 100
						obj.percent = obj.percent.toFixed(2)
						tableData.push(obj)
					}
				}
				tableData = tableData.sort((a, b) => {
					return b.num - a.num
				})
				console.log(groupedData)
				this.groupedData = groupedData
				return tableData
			},
			accordingToDistribution(){
				let amount = this.sourcedata.length
				let tableData = []
				let sourcedata = this.sourcedata.filter((item)=>{
					return (item.reason_uid == '412821904868617542' || item.reason_uid == '170145293685856087') && item.distribution
				})
				let groupedData = this.$Lodash.groupBy(sourcedata, 'distribution')
				for (let i in groupedData) {
					// groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'reason_name')
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'distribution')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.distribution = i
						obj.reason_name = j
						obj.num = groupedData[i][j].length
						obj.percent = obj.num / amount * 100
						obj.percent = obj.percent.toFixed(2)
						tableData.push(obj)
					}
				}
				tableData = tableData.sort((a, b) => {
					return b.num - a.num
				})
				console.log(groupedData)
				this.groupedData = groupedData
				return tableData
			},
			accordingToPacker(){
				let amount = this.sourcedata.length
				let tableData = []
				let sourcedata = this.sourcedata.filter((item)=>{
					return item.reason_uid == '865231255347698832' && item.packer
				})
				let groupedData = this.$Lodash.groupBy(sourcedata, 'packer')
				for (let i in groupedData) {
					// groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'reason_name')
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'packer')
				}
				for (let i in groupedData) {
					for (let j in groupedData[i]) {
						let obj = {}
						obj.id = groupedData[i][j][0].id
						obj.packer = i
						obj.reason_name = j
						obj.num = groupedData[i][j].length
						obj.percent = obj.num / amount * 100
						obj.percent = obj.percent.toFixed(2)
						tableData.push(obj)
					}
				}
				tableData = tableData.sort((a, b) => {
					return b.num - a.num
				})
				console.log(groupedData)
				this.groupedData = groupedData
				return tableData
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				this.modal = true
			},
			detailShow(row){
				//console.log(row,this.groupedData)
				if(this.selectTab=='total'){
					this.detailTitle = '总览明细'
					this.currentdetail = this.groupedData[row.originalStorage][row.reason_name]
				}
				if(this.selectTab=='warehouse'){
					this.detailTitle = '仓库明细'
					this.currentdetail = this.groupedData[row.originalStorage][row.reason_name]
				}
				if(this.selectTab=='distribution'){
					this.detailTitle = '配货明细'
					this.currentdetail = this.groupedData[row.distribution][row.reason_name]
				}
				if(this.selectTab=='packer'){
					this.detailTitle = '打包明细'
					this.currentdetail = this.groupedData[row.packer][row.reason_name]
				}				
				this.$refs.detail.modalShow()
			},
			spanMethod({
				row,
				_rowIndex,
				column,
				visibleData
			}) {
				const fields = ['errortype', 'error']
				const cellValue = row[column.property]
				if (cellValue && fields.includes(column.property)) {
					const prevRow = visibleData[_rowIndex - 1]
					let nextRow = visibleData[_rowIndex + 1]
					if (prevRow && prevRow[column.property] === cellValue) {
						return {
							rowspan: 0,
							colspan: 0
						}
					} else {
						let countRowspan = 1
						while (nextRow && nextRow[column.property] === cellValue) {
							nextRow = visibleData[++countRowspan + _rowIndex]
						}
						if (countRowspan > 1) {
							return {
								rowspan: countRowspan,
								colspan: 1
							}
						}
					}
				}
			}
		},
		components: {
			detailIndex
		}
	}
</script>